import React, { useEffect, useState } from "react";
import classNames from "classnames";
import userDetails from "./services/userTokenDetails";
import "primeicons/primeicons.css";
import "./assets/layout/styling.css";

export const AppTopbar = (props) => {
    var usrDetails = userDetails();
    const [HideTopBar, setHideTopBar] = useState(false);

    useEffect(() => {
        getHeaders();
        const token = localStorage.getItem("access_token");
        if (token && isTokenExpired()) {
            SignOut();
        }
    }, []);

    const getHeaders = () => {
        fetch("config.json", {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                const regDate = data[4]?.RegistrationendDt;
                if (!usrDetails?.role && regDate && new Date() > new Date(regDate)) {
                    setHideTopBar(true);
                } else {
                    setHideTopBar(false);
                }
            });
    };

    const HomePathRoleWise = () => {
        if (usrDetails?.role == "ADMIN" || usrDetails?.role == "ITADMIN") {
            return "/#/home/dashboard";
        } else if (usrDetails?.role == "DOCTOR") {
            return "/#/home/doctorview";
        } else if (usrDetails != null) {
            return "/#/home";
        } else {
            return "/#/";
        }
    };

    const isTokenExpired = () => {
        const token = localStorage.getItem("access_token");
        if (!token) return false;
        const expiration = localStorage.getItem("token_expiration");
        if (!expiration) return false;
        return new Date() > new Date(expiration);
    };

    const SignOut = () => {
        window.location.assign("/");
        localStorage.clear();
    };

    const username = localStorage.getItem("Username") || usrDetails?.fullName;
    const userInitial = username ? username.trim().charAt(0).toUpperCase() : "U";
    const company = localStorage.getItem("Company");
    const userRole = localStorage.getItem("userRole");

    return (
        <div className={HideTopBar === true ? "hidden" : "layout-topbar"}>
            <div className="layout-topbar-left">
                <a href={HomePathRoleWise()} className="layout-topbar-logo-link">
                    <img
                        className="layout-topbar-logo-img cursor-pointer"
                        src={props.layoutColorMode === "light" ? "assets/layout/images/tricoguru-logo-3-1.png" : "assets/layout/images/tricoguru-logo-3-1.png"}
                        alt="T R I C O"
                    />
                </a>

                {usrDetails != null && usrDetails.role !== "DOCTOR" && (
                    <button
                        type="button"
                        className="p-link layout-menu-button layout-topbar-button"
                        onClick={(e) => {
                            if (e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            props.onToggleMenuClick(e);
                        }}
                        title="Toggle Navigation Menu"
                    >
                        <i className="pi pi-bars" />
                    </button>
                )}
            </div>

            {company && (
                <div className="layout-topbar-center">
                    <span className="layout-topbar-company-badge">{company.toUpperCase()}</span>
                </div>
            )}

            {username || userRole ? (
                <div className="layout-topbar-actions">
                    <button
                        type="button"
                        className="p-link layout-topbar-menu-button layout-topbar-button"
                        onClick={(e) => {
                            if (e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            props.onMobileTopbarMenuClick(e);
                        }}
                        title="User Menu"
                    >
                        <i className="pi pi-ellipsis-v" />
                    </button>

                    <ul className={classNames("layout-topbar-menu origin-top", { "layout-topbar-menu-mobile-active": props.mobileTopbarMenuActive })}>
                        <li className="layout-topbar-user-section">
                            <div className="layout-topbar-user-card">
                                <span className="layout-topbar-avatar">{userInitial}</span>
                                <div className="layout-topbar-user-info">
                                    <span className="layout-topbar-username">{username ? username.toUpperCase() : "USER"}</span>
                                    {userRole && <span className="layout-topbar-role">{userRole}</span>}
                                </div>
                            </div>
                        </li>
                        {username && (
                            <li className="layout-topbar-action-item">
                                <button className="p-link layout-topbar-logout-btn" onClick={() => SignOut()} title="Log Out">
                                    <i className="pi pi-sign-out" />
                                    <span>Log Out</span>
                                </button>
                            </li>
                        )}
                    </ul>
                </div>
            ) : (
                <div className="layout-topbar-actions">
                    <a
                        href="/#/"
                        className="p-button p-component p-button-outlined"
                        style={{ textDecoration: "none", fontSize: "1rem", padding: "0.5rem 1rem", borderRadius: "6px" }}
                        title="Sign In"
                    >
                        <i className="pi pi-sign-in mr-2" />
                        <span>Sign In</span>
                    </a>
                </div>
            )}
        </div>
    );
};

